import { createMintSocketBuilder } from '@mint-lib/api-zod-support/socket';
import z from 'zod';

import { BulkTaskStatusSchema } from '../usersBulk/schemas.js';

export const BULK_TASKS_SOCKET_PATH =
  '/api/authentication/v1/bulk-tasks/ws' as const;

export const bulkTasksSocket = createMintSocketBuilder({
  onValidationError: (error) => {
    if (import.meta.env.DEV) {
      console.error('[bulkTasksSocket] invalid message', error);
    }
  },
});

// Sent once after connecting to stream a single task's progress.
export const subscribeBulkTask = bulkTasksSocket.defineSend({
  topic: 'subscribe_bulk_task',
  payloadSchema: z.object({ taskId: z.string() }),
});

// Pushed by the BE on every progress tick and on completion.
export const onBulkTaskUpdate = bulkTasksSocket.defineSubscribe({
  topic: 'bulk_task_update',
  payloadSchema: BulkTaskStatusSchema,
});
